/*
 * Copyright (c) Nexign, JSC, 2019.
 */

/**
 *
 *
 * @author Yakov Gushchin
 * @author Anton Panasenko
 * @author Maxim Fedorov
 * @version 1.1.0
 * @since 1.1.0
 */

import { createElement } from 'react';

import {
    ChartCategoryAnimate,
    ChartCategoryColumnWidthConfiguration,
    ChartCategoryDataConfiguration,
    ChartCategoryGridConfiguration,
    ChartCategoryHeight,
    ChartCategoryLegendConfiguration,
    ChartCategoryPadding,
    ChartCategoryScaleConfiguration,
    ChartCategoryTooltipConfiguration,
    ChartCategoryType,
} from './ChartCategory/ChartCategory';
import { ChartCategoryErrorConfiguration } from './ChartCategory/ChartCategoryError';
import { ChartCategoryLoadingConfiguration } from './ChartCategory/ChartCategoryLoading';
import { ChartCategoryStyled } from './ChartCategory/styled/ChartCategotyStyled';
import {
    ChartDynamicAnimate,
    ChartDynamicDataConfiguration,
    ChartDynamicGridConfiguration,
    ChartDynamicHeight,
    ChartDynamicLegendConfiguration,
    ChartDynamicPadding,
    ChartDynamicScaleConfiguration,
    ChartDynamicTooltipConfiguration,
    ChartDynamicType,
} from './ChartDynamic/ChartDynamic';
import { ChartDynamicErrorConfiguration } from './ChartDynamic/ChartDynamicError';
import { ChartDynamicLoadingConfiguration } from './ChartDynamic/ChartDynamicLoading';
import { ChartDynamicStyled } from './ChartDynamic/styled/ChartDynamicStyled';
import { EChartImplementationType, IChartImplementation } from './chartImplementationTypes';

export const getChartImplementation =
    (implementationType: EChartImplementationType): IChartImplementation => {
        switch (implementationType) {
            case EChartImplementationType.dynamic:
                return {
                    animate: ChartDynamicAnimate,
                    dataConfiguration: ChartDynamicDataConfiguration,
                    error: ChartDynamicErrorConfiguration,
                    grid: ChartDynamicGridConfiguration,
                    height: ChartDynamicHeight,
                    legend: ChartDynamicLegendConfiguration,
                    loading: ChartDynamicLoadingConfiguration,
                    padding: ChartDynamicPadding,
                    render: () => createElement<HTMLDivElement>(ChartDynamicStyled),
                    scale: ChartDynamicScaleConfiguration,
                    tooltip: ChartDynamicTooltipConfiguration,
                    type: ChartDynamicType,
                };
            case EChartImplementationType.category:
            default:
                return {
                    animate: ChartCategoryAnimate,
                    columnWidth: ChartCategoryColumnWidthConfiguration,
                    dataConfiguration: ChartCategoryDataConfiguration,
                    error: ChartCategoryErrorConfiguration,
                    grid: ChartCategoryGridConfiguration,
                    height: ChartCategoryHeight,
                    legend: ChartCategoryLegendConfiguration,
                    loading: ChartCategoryLoadingConfiguration,
                    padding: ChartCategoryPadding,
                    render: () => createElement<HTMLDivElement>(ChartCategoryStyled),
                    scale: ChartCategoryScaleConfiguration,
                    tooltip: ChartCategoryTooltipConfiguration,
                    type: ChartCategoryType,
                };
        }
    };
